import styled from 'styled-components';
import { Box } from '@mui/material';

export const InviteContainer = styled(Box)`
    display: flex;
    align-items: center;
    gap: 16px;
    margin-bottom: 24px;
`;

export const InviteInputRow = styled(Box)`
    display: flex;
    align-items: center;
    gap: 8px;
`;
